import { createSelector } from '@reduxjs/toolkit';

const selectBMIEntries = (state) => state.entities.participantService.bmiEntries;

const selectCurrentParticipantEntry = (state) =>
    state.entities.participantService.currentParticipant;

const selectCurrentParticipantBarrierEntries = (state) =>
    state.entities.participantService.currentParticipantBarriers;

export const selectSortedBMIEntries = createSelector(selectBMIEntries, (bmiEntries) => {
    const entries = bmiEntries.map((el) => ({
        ...el,
        parsedDate: Date.parse(el.eventDate)
    }));
    return entries.sort((a, b) => a.parsedDate - b.parsedDate);
});

const selectSmokingQuitAttemptsEntries = (state) =>
    state.entities.participantService.smokingQuitAttempts;

export const selectCurrentParticipant = createSelector(
    selectCurrentParticipantEntry,
    (currentParticipant) => currentParticipant
);

export const selectCurrentParticipantsName = createSelector(
    selectCurrentParticipant,
    (currentParticipant) => `${currentParticipant.firstName} ${currentParticipant.lastName}`
);

export const selectCurrentParticipantBarriers = createSelector(
    selectCurrentParticipantBarrierEntries,
    (currentParticipantBarriers) => currentParticipantBarriers
);

export const selectSmokingQuitAttempts = createSelector(
    selectSmokingQuitAttemptsEntries,
    (smokingQuitAttempts) => {
        const entries = smokingQuitAttempts.map((el) => ({
            ...el,
            parsedDate: Date.parse(el.quitDate)
        }));
        return entries.sort((a, b) => b.parsedDate - a.parsedDate);
    }
);
